/* eslint arrow-body-style: 0 */
import ContactImporter from './pages/ContactImporter';
import { frontendURL } from '../../../helper/URLHelper';
const ContactsView = () => import('./components/ContactsView.vue');
const ContactManageView = () => import('./pages/ContactManageView.vue');
const InHouseView = () => import('./components/InHouseView.vue');

export const routes = [
  {
    path: frontendURL('accounts/:accountId/contacts'),
    name: 'contacts_dashboard',
    meta: {
      permissions: ['administrator', 'agent'],
    },
    component: ContactsView,
  },
  {
    path: frontendURL('accounts/:accountId/contacts/custom_view/:id'),
    name: 'contacts_segments_dashboard',
    meta: {
      permissions: ['administrator', 'agent'],
    },
    component: ContactsView,
    props: (route) => {
      return { segmentsId: route.params.id };
    },
  },
  {
    path: frontendURL('accounts/:accountId/labels/:label/contacts'),
    name: 'contacts_labels_dashboard',
    meta: {
      permissions: ['administrator', 'agent'],
    },
    component: ContactsView,
    props: (route) => {
      return { label: route.params.label };
    },
  },
  // chatlyn
  {
    path: frontendURL('accounts/:accountId/lists/:listId/contacts'),
    name: 'contacts_lists_dashboard',
    meta: {
      permissions: ['administrator', 'agent'],
    },
    component: ContactsView,
    props: (route) => {
      return { listId: route.params.listId };
    },
  },
  // chatlyn
  {
    path: frontendURL('accounts/:accountId/contacts/importer'),
    name: 'contacts_importer_dashboard',
    meta: {
      permissions: ['administrator', 'agent'],
    },
    component: ContactImporter,
  },
  {
    path: frontendURL('accounts/:accountId/contacts/in-house'),
    name: 'in_house_contacts_dashboard',
    meta: {
      permissions: ['administrator', 'agent'],
    },
    component: InHouseView,
  },
  {
    path: frontendURL('accounts/:accountId/contacts/:contactId'),
    name: 'contact_profile_dashboard',
    meta: {
      permissions: ['administrator', 'agent'],
    },
    component: ContactManageView,
    props: (route) => {
      return { contactId: route.params.contactId };
    },
  },
];
